import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { cancelHotelReservation, getPropertyList } from "../../../const/RTCC";
import MessageConst from "../../../const/RTCC/messageConst";
import common from "../../../resources/RTCC/js/common/common";
import CommonUtil from "../../../common/commonUtil";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { ErrorMassage } from "../../molecules/RTCC/errorMassage";
import { LabelBookingForm } from '../../molecules/RTCC/labelBookingForm';
import './../../../resources/RTCC/css/reservationConfirm/reservationConfirm.css';
import { FooterContainer } from './footerContainer';
import { useRtoaster } from "../../../hooks/useRtoaster";



const RtccBookingCancelContainer = (props) => {
    const {
        login,
        toUserInputInfo,
        setToUserInputInfo,
        onChange,
        onClickOpenCalendarWindow,
        checkIn,
        checkOut,
        reserveInfo,
        setReserveInfo,
        reserveCancelInfo,
        setReserveCancelInfo,
        onClickOpenCancelPopupWindow,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);

    // プロパティ一覧
    const [paymentMtd, setPaymentMtd] = useState([]);
    const [customerAge, setCustomerAge] = useState([]);
    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });

    // rtoasterタグ生成
    const customParam = {
        "hotelid": reserveCancelInfo.hotelId,
        "riyodat": reserveCancelInfo.checkInDate,
        "yoyakuno": reserveCancelInfo.reserveId,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
            common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if(!res.data){
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        // プロパティ一覧取得
        common.doPost(getPropertyList, { propertyTypeList: ["PAYMENT_MET", "CUSTOMER_AGE"] }, afterGetPropertyList);
        setToUserInputInfo(toUserInputInfo);
        setReserveInfo(reserveInfo);
        setReserveCancelInfo(reserveCancelInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }, { path: "/reserve/rtcc/bookingConfirmDetail", label: "RTCC予約内容確認" }]);

    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const afterGetPropertyList = (res) => {
        let data = res.data;
        if (data) {
            if (data.propertyInfoList && data.propertyInfoList.length != 0) {
                let propertyInfoList = data.propertyInfoList;
                propertyInfoList.map((value, index) => {
                    let dataList = [];
                    switch (value.propertyType) {
                        case "PAYMENT_MET":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = { id: property.propertyId, value: property.propertyName };
                                dataList.push(obj);
                            })
                            setPaymentMtd(dataList);
                            break;
                        case "CUSTOMER_AGE":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = { id: property.propertyId, value: property.propertyName };
                                dataList.push(obj);
                            })
                            setCustomerAge(dataList);
                            break;
                        default:
                            break;
                    }
                })
            }
        } else {
            // エラー処理
        }
    }

    return (
        <div className="reserveCancelInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="予約のキャンセル"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                <ErrorMassage data={errorInfo.errorMessage} />
            </div>
            <div className="reserveConirmWrapper">
                <div className="reserveContentWrapper">
                    <Label label="ご予約内容" className="reserveConirmTitle2" />
                    <div className="reservationContentsWrap">
                        <div className="reservationContents">
                            <Label
                                label="ご利用日程"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={reserveCancelInfo.checkInDate + "\n" + "～" + "\n" + reserveCancelInfo.checkOutDate}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="施設名"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={reserveCancelInfo.hotelName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="お部屋タイプ"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={reserveCancelInfo.roomName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="予約番号"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={reserveCancelInfo.reserveId}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="userInputWrapper -booking">
                <div className="reserveConfirmWrapper2">
                    <Label
                        label={"宿泊情報"}
                        className="completeContentsTitleLabel"
                    />
                    <div className="cancelWrap">
                        <LabelBookingForm
                            label="部屋数"
                            type={"id"}
                            id="roomNum"
                            value={props.id}
                            className="inputKeyword"
                            labelClassName="confirmTextLabel"
                            wrapClassName="popupWrapLong"
                            bookingText={reserveCancelInfo.roomList ? reserveCancelInfo.roomList.length + "室" : 0 + "室"}
                            labelWrap="confirmbookingLabelTextWrap2"
                            confirmLabelTextClassName="completeTextLabel2"
                        />
                        {reserveCancelInfo.roomList ? reserveCancelInfo.roomList.map((room, roomIndex) => {
                            return <>
                                <div className="confirmbookingLabelTextWrap" >
                                    <Label label={room.roomCount + "部屋目"} className="confirmTextLabel" />
                                    <div className="completeTextLabel2">
                                        {room.ageInfo ? room.ageInfo.map((guest, guestIndex) => {
                                            return <>
                                                <Label
                                                    label={customerAge.find(option => option.id == guest.ageGroupId) ?
                                                        customerAge.find(option => option.id == guest.ageGroupId).value : ""}
                                                    className="confirmLabel"
                                                />
                                            </>
                                        }) : null}
                                    </div>
                                </div>
                            </>
                        }) : null}
                        <LabelBookingForm
                            label={"お支払い旅行代金"}
                            type={"id"}
                            id="roomNum2"
                            value={props.id}
                            className="inputKeyword"
                            labelClassName="confirmTextLabel"
                            wrapClassName="popupWrapLong"
                            labelWrap="confirmbookingLabelTextWrap bold"
                            bookingText={"¥" + Number(reserveCancelInfo.fee).toLocaleString()}
                            confirmLabelTextClassName="confirmTextLabelBold"
                        />
                    </div>
                </div>
            </div>
            <div className="reserveConirmWrapper">
                <div className="reserveContentWrapper3">
                    <Label
                        label={"お支払い方法"}
                        className="reserveConirmTitle2"
                    />
                    <div className="bookingWrap">
                        <Label
                            className="rtcc_inputContentLabel"
                            label={paymentMtd.find(option => option.id == reserveCancelInfo.paymentId) ?
                                paymentMtd.find(option => option.id == reserveCancelInfo.paymentId).value : ""}
                        />
                    </div>
                </div>
            </div>
            <div className="reserveConirmWrapper">
                <div className="reserveContentWrapper2">
                    <Label
                        label={"取消規約"}
                        className="reserveConirmTitle2"
                    />
                    <div className="bookingWrap">
                        <Label
                            className="btnDoCancelLabel"
                            label={CommonUtil.replaceSpecialChar(reserveCancelInfo.cancelContents)}
                        />
                    </div>
                </div>
            </div>
            <div className="btnToBookingWrapper2">
                <div class="btnCancelBoxWrap">
                    <Button buttonText="予約をキャンセル" className="btnDoCancelConfirm" onClick={onClickOpenCancelPopupWindow} buttonClassName="btnCancelConfirmText" />
                </div>
                <div class="confirmToTop">
                    <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        toUserInputInfo: state.toUserInputInfo,
        reserveInfo: state.reserveInfo,
        reserveCancelInfo: state.reserveCancelInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setReserveInfo: (item) => {
            dispatch({ type: "RESERVE_INFO", payload: { reserveInfo: item } })
        },
        setReserveCancelInfo: (item) => {
            dispatch({ type: "RESERVE_CANCEL_INFO", payload: { reserveCancelInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccBookingCancelContainer);

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid #bfbec5",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        display: "flex",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "30px 0px",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0.94)",
        border: 0,
        fontWeight: "bold"
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
}
